
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import AppLayout from "./components/layout/AppLayout";

// Simple QueryClient configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  console.log('[App] App component rendering');

  useEffect(() => {
    // Ensure body visibility
    document.body.style.display = 'block';
    document.body.style.visibility = 'visible';
    document.body.style.opacity = '1';
    document.body.style.backgroundColor = '#ffffff';
    
    console.log('[App] App loaded successfully');
  }, []);

  return (
    <div 
      data-testid="app-container"
      style={{
        display: 'block',
        visibility: 'visible',
        opacity: 1,
        minHeight: '100vh',
        width: '100%',
        backgroundColor: '#ffffff'
      }}
    >
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <BrowserRouter>
            <AppLayout />
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
